import type { Provider } from '@angular/core';
import type {
  IMetadataKeyRepository,
  ICryptoAdapter,
  IBiometricAuthPort,
  IDatabaseService,
  IDatabaseSnapshotPort,
} from '@app/domain/ports';
import { DatabaseSnapshotAdapter } from '@app/infrastructure/storage';
import {
  ActivateWebAuthnUseCase,
  DeactivateWebAuthnUseCase,
  EnablePinLoginUseCase,
  DisablePinLoginUseCase,
  UpdatePasswordUseCase,
  RegistrationUseCase,
} from '@app/domain/use-cases';
import {
  METADATA_KEY_REPOSITORY,
  CRYPTO_ADAPTER,
  BIOMETRIC_AUTH,
  DATABASE_SERVICE,
  DATABASE_SNAPSHOT_ADAPTER,
} from '../../tokens/infrastructure.tokens';

export function provideAuthDomain(): Provider[] {
  return [
    {
      provide: ActivateWebAuthnUseCase,
      useFactory: (repo: IMetadataKeyRepository, crypto: ICryptoAdapter, biometric: IBiometricAuthPort) =>
        new ActivateWebAuthnUseCase(repo, biometric, crypto),
      deps: [METADATA_KEY_REPOSITORY, CRYPTO_ADAPTER, BIOMETRIC_AUTH],
    },
    {
      provide: DeactivateWebAuthnUseCase,
      useFactory: (repo: IMetadataKeyRepository) => new DeactivateWebAuthnUseCase(repo),
      deps: [METADATA_KEY_REPOSITORY],
    },
    {
      provide: EnablePinLoginUseCase,
      useFactory: (repo: IMetadataKeyRepository, crypto: ICryptoAdapter) => new EnablePinLoginUseCase(repo, crypto),
      deps: [METADATA_KEY_REPOSITORY, CRYPTO_ADAPTER],
    },
    {
      provide: DisablePinLoginUseCase,
      useFactory: (repo: IMetadataKeyRepository) => new DisablePinLoginUseCase(repo),
      deps: [METADATA_KEY_REPOSITORY],
    },
    {
      provide: UpdatePasswordUseCase,
      useFactory: (repo: IMetadataKeyRepository, crypto: ICryptoAdapter) => new UpdatePasswordUseCase(repo, crypto),
      deps: [METADATA_KEY_REPOSITORY, CRYPTO_ADAPTER],
    },
    {
      provide: DATABASE_SNAPSHOT_ADAPTER,
      useFactory: (db: IDatabaseService, crypto: ICryptoAdapter, repo: IMetadataKeyRepository): IDatabaseSnapshotPort =>
        new DatabaseSnapshotAdapter(db, crypto, repo),
      deps: [DATABASE_SERVICE, CRYPTO_ADAPTER, METADATA_KEY_REPOSITORY],
    },
    {
      provide: RegistrationUseCase,
      useFactory: (
        repo: IMetadataKeyRepository,
        db: IDatabaseService,
        crypto: ICryptoAdapter,
        snapshot: IDatabaseSnapshotPort,
      ) => new RegistrationUseCase(repo, db, crypto, snapshot),
      deps: [METADATA_KEY_REPOSITORY, DATABASE_SERVICE, CRYPTO_ADAPTER, DATABASE_SNAPSHOT_ADAPTER],
    },
  ];
}
